import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoBaseFormControlComponent } from '../eo-base-form-control/eo-base-form-control.component';
import { InputType } from '../eo-input/eo-input.model';
import { EoCheckboxConfig } from './eo-checkbox.model';

@Component({
  selector: 'eo-checkbox',
  templateUrl: './eo-checkbox.component.html',
  styleUrl: './eo-checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoCheckboxComponent),
      multi: true,
    },
  ],
})
export class EoCheckboxComponent extends EoBaseFormControlComponent {
  protected override _config?: EoCheckboxConfig;
  override get config(): EoCheckboxConfig | undefined {
    return this._config;
  }
  override set config(val: EoCheckboxConfig | undefined) {
    this._config = val;
  }

  @Input() type?: InputType;
  @Input() value?: any;
  @Input() checkboxStyleClass?: string;

  protected getType(): string {
    return this.type ?? this.config?.type ?? 'checkbox';
  }

  protected getValue(): any {
    return this.config?.value ?? this.value ?? '';
  }
}
